import { Cuenta, SaveCuentaDto } from "./cuenta";
import { Persona } from "./persona";

export class Proveedor {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly RazonSocial: string | null,
        public readonly TipoDocumentoId: number | null,
        public readonly TipoDocumentoNombre: string | null,
        public readonly NroDocumento: string | null,
        public readonly PaisId: number | null,
        public readonly PaisNombre: string | null,
        public readonly Domicilio: string | null,
        public readonly CodigoPostal: string | null,
        public readonly LocalidadBarrio: string | null,
        public readonly Observacion: string | null,
        public readonly Activo: boolean | null,
        public PersonaContactoId: number | null,
        public PersonaContacto: Persona | null,
        public PersonaContactoOpcionalId: number | null,
        public PersonaContactoOpcional: Persona | null,
        public Cuentas: Cuenta[]
    ) { }
}

export class SearchProveedorRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly RazonSocial: string | null,
        public readonly NroDocumento: string | null,
        public readonly PersonaId: number | null,
        public readonly PaisId: number | null,
        public readonly ActividadId: number | null,
        public readonly VerSoloActivos: boolean | null
    ) { }
}

export class SaveProveedorDto {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly RazonSocial: string | null,
        public readonly NroDocumento: string | null,
        public readonly PaisId: number | null,
        public readonly PaisNombre: string | null,
        public readonly Domicilio: string | null,
        public readonly CodigoPostal: string | null,
        public readonly LocalidadBarrio: string | null,
        public readonly Observacion: string | null,
        public readonly Activo: boolean,
        public readonly PersonaContactoId: number | null,
        public readonly PersonaContactoOpcionalId: number | null,
        public readonly PersonaContacto: Persona | null,
        public readonly PersonaContactoOpcional: Persona | null,
        public Cuentas: SaveCuentaDto[]
    ) { }
}

export class ReporteProductividadDto {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly RazonSocial: string | null,
        public readonly Cuit: number,
        public readonly ActividadPrincipalId: number,
        public readonly ActividadPrincipalNombre: string | null,

        //Pedidos
        public readonly TotalPedidosEntregados: number,
        public readonly CantidadPedidosEntregadosEnFecha: number,
        public readonly CantidadPedidosEntregadosParcial: number,
        public readonly PedidosPlazoEntregaPromedio: number,
        public readonly PedidosEntregadosMontoPromedio: any,

        //Presupuestos
        public readonly TotalPresupuestosRealizados: number,
        public readonly CantidadPresupuestosSeleccionados: number,
        public readonly CantidadPresupuestosIncluyeFlete: number,
        public readonly PresupuestoMontoPromedio: any,

        //Gastos
        public readonly TotalGastosAsignados: number,
        public readonly GastoMontoPromedio: any
    ) { }
}
